import { useState } from "react";
import { StructuresTab } from "../components/organisms";
import { useListStructuresUrlQuery } from "../api/structures/structures.queries";
import { LoadingBlurDiv } from "@shared/components";
import { ClientSelector } from "../../clients";

const StructuresPage = () => {
  const [selectedClient, setSelectedClient] = useState<string | null>(null);

  const { query, setFilters, resetFilters, currentFilters } =
    useListStructuresUrlQuery(selectedClient);

  return (
    <>
      <ClientSelector onSelect={setSelectedClient} />
      {selectedClient && (
        <LoadingBlurDiv isLoading={query.isFetching}>
          <StructuresTab
            tenantId={selectedClient}
            structures={query.data?.data || []}
            paginatedMeta={query.data?.meta}
            isLoading={query.isFetching}
            onFilter={setFilters}
            onClearFilter={resetFilters}
            initialFilters={currentFilters}
          />
        </LoadingBlurDiv>
      )}
    </>
  );
};

export default StructuresPage;
